import api from './api'
import {
  AdminReportsData,
  DashboardStats,
  GetAdminReportsParams
} from '../types/api'

interface DashboardResponse {
  success: boolean
  data: DashboardStats
}

interface ReportsResponse {
  success: boolean
  data: AdminReportsData
}

const statsService = {
  async getDashboard(): Promise<DashboardStats> {
    const response = await api.get<DashboardResponse>('/stats/dashboard')
    return response.data.data
  },

  async getReports(params: GetAdminReportsParams = {}): Promise<AdminReportsData> {
    const response = await api.get<ReportsResponse>('/stats/reports', {
      params
    })
    return response.data.data
  }
}

export default statsService
